import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-non-buyable-parts',
  templateUrl: './non-buyable-parts.component.html',
  styleUrls: ['./non-buyable-parts.component.scss'],
})
export class NonBuyablePartsComponent implements OnInit {
  nonBuyableProducts: any[]

  nonSellableArr: any[]

  constructor(protected launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.nonBuyableProducts = data.nonBuyableProducts
    })
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.NON_BUYABLE_PARTS,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
